import { render, staticRenderFns } from "./keche.vue?vue&type=template&id=13a13f26&"
import script from "./keche.vue?vue&type=script&lang=js&"
export * from "./keche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports